import cartFragment from './fragmentCart.gql';

const cartRetrieve = (
	`query ($id: ID!) {
	  node(id: $id) {
	  	id
	  	... on Cart ${cartFragment}
	  }
	}`
);

export default cartRetrieve;
